import React from "react";
import { A2uiSurface } from "@a2ui/react/v0_9";

// Thin wrapper around the real @a2ui/react v0.9 renderer. There is no
// "A2UIProvider" in the real v0.9 API (that only exists in the legacy v0.8
// export, which uses different message names). A surface is just a
// `SurfaceModel` object (from `MessageProcessor.model.getSurface(id)`)
// handed straight to `<A2uiSurface surface={...} />` - each chat turn gets
// its own SurfaceModel keyed by the surfaceId the backend chose in its
// `createSurface` message, so turns never share or overwrite each other's
// rendered surface. This wrapper exists as the one seam to change if a
// future @a2ui/react version needs extra per-surface setup.
const AnalyticsSurface = ({ surface }) => {
  if (!surface) return null;
  return (
    <div className="analytics-chat-surface">
      <A2uiSurface surface={surface} />
    </div>
  );
};

export default AnalyticsSurface;
